import React, { useState } from "react";
import topDivider from "../../imgs/top-divider.png";
import bottomDivider from "../../imgs/bottom-divider.svg";
import "./Menu.css";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom"; // ← Import the navigate hook

const menuTabs = ["Drinks", "Meals", "Lunch"];

const menuItems = {
  Drinks: [
    {
      name: "American",
      description: "A smooth, bold brewed coffee served hot or iced — simple, classic, and endlessly satisfying.",
      price: "$3.25",
      icon: <Icon icon="mdi:coffee-outline" width="48" height="48" />,
    },
    {
      name: "Espresso",
      description: "A rich and intense shot of pure coffee perfection. Strong, aromatic, and the heart of every great cup.",
      price: "$2.99",
      icon: <Icon icon="mdi:coffee-outline" width="48" height="48" />,
    },
    {
      name: "Chai Tea",
      description: "Warm spices blended with black tea and steamed milk — a cozy, creamy pick-me-up with a kick.",
      price: "$4.99",
      icon: <Icon icon="mdi:tea-outline" width="48" height="48" />,
    },
    {
      name: "Cappuccino",
      description: "A balanced mix of espresso, steamed milk, and foam — bold, creamy, and perfect for sipping slow.",
      price: "$4.75",
      icon: <Icon icon="mdi:coffee-outline" width="48" height="48" />,
    },
    {
      name: "Latte",
      description: "A mellow blend of espresso and steamed milk, finished with a light layer of foam. Smooth and comforting.",
      price: "$4.95",
      icon: <Icon icon="mdi:coffee-outline" width="48" height="48" />,
    },
    {
      name: "Mocha",
      description: "Espresso meets rich chocolate and velvety milk — finished with whipped cream for a decadent treat.",
      price: "$4.60",
      icon: <Icon icon="mdi:coffee-outline" width="48" height="48" />,
    },
  ],

  Meals: [
    {
      name: "Egg House Favorite",
      description: "Hash browns topped with 2 eggs, sautéed pork sausage, onions, and peppers, smothered with cheese or hollandaise. Served with toast.",
      price: "$10.99",
      icon: <Icon icon="ic:outline-egg-alt" width="48" height="48" />,
    },
    {
      name: "Perfect Team",
      description: "Two eggs, crispy hash browns, and toast. Add ham, bacon, sausage, or a beef patty to build your plate.",
      price: "$7.90",
      icon: <Icon icon="ic:outline-egg-alt" width="48" height="48" />,
    },
    {
      name: "Sirloin & Eggs",
      description: "A juicy 5 oz. sirloin steak grilled to order, served with eggs, hash browns, and toast.",
      price: "$10.99",
      icon: <Icon icon="mdi:food-steak" width="48" height="48" />,
    },
    {
      name: "Short Stack Pancakes",
      description: "Two fluffy pancakes with your choice of ham, bacon, or sausage. Sweet and satisfying.",
      price: "$8.50",
      icon: <Icon icon="lucide-lab:pancakes" width="48" height="48" />,
    },
    {
      name: "Full Stack Pancakes",
      description: "Three stacked pancakes served with your favorite breakfast meat. Add fruit or chocolate chips for $1.",
      price: "$9.50",
      icon: <Icon icon="lucide-lab:pancakes" width="48" height="48" />,
    },
    {
      name: "French Toast Combo",
      description: "Three thick slices of golden French toast with ham, bacon, or sausage. Topped with optional fruit compote.",
      price: "$9.50",
      icon: <Icon icon="mdi:bread-slice-outline" width="48" height="48" />,
    },
  ],

  Lunch: [
    {
      name: "Chicken Quesadillas",
      description: "Grilled tortillas packed with spicy chicken, cheddar cheese, tomatoes, and onions. Served hot and melty.",
      price: "$7.99",
      icon: <Icon icon="lineicons:pie-chart-2" width="48" height="48" />,
    },
    {
      name: "Sampler Platter",
      description: "A shareable trio of chicken strips, mozzarella sticks, and crispy onion rings. Comes with dipping sauces.",
      price: "$10.50",
      icon: <Icon icon="fluent-emoji-high-contrast:fork-and-knife-with-plate" width="48" height="48" />,
    },
    {
      name: "Taco Salad",
      description: "A crispy tortilla bowl filled with seasoned taco meat, lettuce, tomatoes, cheddar cheese, and guac.",
      price: "$10.99",
      icon: <Icon icon="mdi:taco" width="48" height="48" />,
    },
    {
      name: "Reuben Sandwich",
      description: "Grilled rye stacked with shaved corned beef, Swiss cheese, sauerkraut, and Thousand Island dressing.",
      price: "$10.99",
      icon: <Icon icon="mdi:bread-slice-outline" width="48" height="48" />,
    },
    {
      name: "Chicken Caesar Wrap",
      description: "Grilled chicken breast with romaine, tomato, onion, croutons, and Caesar mayo wrapped in a soft tortilla.",
      price: "$10.99",
      icon: <Icon icon="fluent-emoji-high-contrast:burrito" width="48" height="48" />,
    },
    {
      name: "Western Burger",
      description: "Our 1/3 lb beef patty topped with bacon, American cheese, and tangy BBQ sauce on a toasted bun.",
      price: "$10.99",
      icon: <Icon icon="streamline:burger" width="48" height="48" />,
    },
  ],
};

function StudiosSection() {
  const [activeTab, setActiveTab] = useState("Drinks");
  const navigate = useNavigate(); // ← Hook for routing

  return (
    <>
    <img src={topDivider} alt="Top Divider" className="top-divider-image" />
    <section className="home-menu-preview-section">
      <h2 className="home-menu-title">Menu</h2>

      <div className="home-menu-tabs">
        {menuTabs.map((tab) => (
          <button
            key={tab}
            className={`home-menu-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="home-menu-items">
        {menuItems[activeTab].map((item, index) => (
          <div key={index} className="home-menu-item">
            <div className="home-menu-icon">{item.icon}</div>
            <div className="home-menu-info">
              <div className="home-menu-header">
                <h4>{item.name}</h4>
                <span className="home-menu-price">{item.price}</span>
              </div>
              <p className="home-menu-description">{item.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="home-menu-button-wrapper">
        <button className="home-menu-button" onClick={() => navigate("/menu")}>
          View Full Menu
        </button>
      </div>
    </section>
    <img src={bottomDivider} alt="Top Divider" className="top-divider-image" />
    </>
  );
}

export default StudiosSection;
